export const AUDIT_LOGS_TEST_IDS = {
  filterByLabel: 'audit-logs-filter-by-label',
  filtersRow: 'audit-logs-filters-row',
  businessUnitInput: 'audit-logs-business-unit-input',
  businessUnitSelect: 'audit-logs-business-unit-select',
  startDateInput: 'audit-logs-start-date-input',
  endDateInput: 'audit-logs-end-date-input',
  refreshButton: 'audit-logs-refresh-button',
  viewingCount: 'audit-logs-viewing-count',
  table: 'audit-logs-table',
  emptyState: 'audit-logs-empty-state',
  loadMoreButton: 'audit-logs-load-more-button',
  exportButton: 'audit-logs-export-button',
  exportDialog: 'audit-logs-export-dialog',
  exportMonthSelect: 'audit-logs-export-month-select',
  exportWeekSelect: 'audit-logs-export-week-select',
  exportCustomRangeNote: 'audit-logs-export-custom-range-note',
  exportStartDateInput: 'audit-logs-export-start-date-input',
  exportEndDateInput: 'audit-logs-export-end-date-input',
  exportUserSelect: 'audit-logs-export-user-select',
  exportSubmitButton: 'audit-logs-export-submit-button',
} as const;
